import React, { useState, useContext } from "react";
import Head from "next/head";
import Image from "next/image";
import styles from "./../signature.module.css";
import { countryCards, signatureBlog } from "../../../constants/signature";
import { legalCountries } from "@constants/signature";
import Blog from "../../../components/CalculatorBlogs/Blog";
import { useRouter } from "next/router";
import { BASE_URL, BASE_ASSETS_URL } from "../../../constants/constants";
import AppContext from "../../../components/AppContext";
import CtaOne from "@components/CTA/CtaOne";
import CompanyOverview from "@components/CompanyOverview";
import ClientsTestimonial from "@components/Cards/ClientsTestimonial";
import Legality from "@components/Legality";
import Subscribe from "@components/Subscribe";
import CustomersMarquee from "components/CLM/Customers";
import { industryLeadersCard } from "@constants/customersData";

export async function getServerSideProps(context) {
  const request = await fetch(`${BASE_URL}legal-list`);
  const response = await request.json();
  const legalList = await response.legalList.map((country) => {
    country.code = country.code.toLowerCase();
    return country;
  });
  return {
    props: {
      countries: legalList,
    },
  };
}

const ElectricSignatureLegality = ({ countries }) => {
  let router = useRouter();
  const context = useContext(AppContext);
  const [selectedCountry, setSelectedCountry] = useState("Select Country");

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
    router.push(`/signature/electric-signature-legality/${event.target.value}`);
  };
  return (
    <div className="mt-8 md:mt-20">
      <Head>
        <meta charSet="utf-8" />
        <title>
          Are eSignatures legal? | Electronic Signature Laws by Country
        </title>
        <meta
          name="description"
          content="An eSignature provides the same legal standing as a handwritten signature as long as it adheres to the requirements of the specific regulation it was created under. Join millions of professionals and business owners that have replaced manual paper signing for the speed and security of eSignatures."
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="Boloforms" />
        <meta name="publisher" content="BoloForms" />
        <meta
          name="keywords"
          content="Are eSignatures legal, Electronic Signature Laws by Country, eSignature Laws, eSignature Laws by Country, eSignature Laws by Country 2022, eSignature Laws by Country 2023"
        />
        <meta
          property="og:url"
          content="https://www.bolosign.com/signature/electric-signature-legality/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Are eSignatures legal? | Electronic Signature Laws by Country"
        />
        <meta name="twitter:site" content="@boloforms" />
        <meta
          property="twitter:url"
          content="https://www.bolosign.com/signature/electric-signature-legality/"
        />
        <meta
          name="twitter:title"
          content="Are eSignatures legal? | Electronic Signature Laws by Country"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@boloforms" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta name="twitter:description" content="" />
        <meta property="og:description" content="" />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href="https://www.bolosign.com/signature/electric-signature-legality/"
        />
      </Head>
      <div className="flex flex-col gap-24 md:gap-40">
        <div className="w-full max-w-screen-xl  mx-auto px-4 md:px-8 ">
          <Legality dropDown={true} />
        </div>
        {/* <div className={`w-full pt-12 pb-0 md:py-12 bg-cyan-50`}>
          <div
            className={`w-full max-w-screen-xxl mx-auto flex flex-col md:flex-row justify-between items-center gap-10 px-4 lg:px-8 xxl:px-0`}
          >
            <div className="flex-1 flex flex-col gap-3">
              <CtaOne
                heading2={`Electronic Signature Legality`}
                paragraph={`Electronic signatures are legally accepted in over 60 countries, making business easier and greener. Our guide explains eSignature laws worldwide in simple terms.`}
                // buttonPrimaryText={`Try eSignature Free`}
                // buttonPrimaryUrl={`https://signature.boloforms.com/login?from=${
                //   context.globalData.from || "ELECTRONIC_SIGNATURE_LEGALITY"
                // }`}
              />
              <div className="max-w-[350px] h-[50px] md:h-[60px] border border-gray-800 rounded-lg bg-transparent pr-2">
                <select
                  className="h-full w-full border-none outline-none text-black bg-transparent text-lg md:text-xl pl-6 py-2"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  <option value="" className="bg-black text-white">
                    Select Country
                  </option>
                  {countries.length > 0 &&
                    legalCountries.map((legal, index) => (
                      <option
                        key={index}
                        value={legal.country}
                        className="bg-black text-white"
                      >
                        {legal.country}
                      </option>
                    ))}
                </select>
              </div>
              <div className="text-xs mt-10 pt-8 border-t-[1px] border-gray-500 text-gray-700">
                ESIGN Act Sec 106 (US federal law), GPEA Sec 1710 (US federal
                law), UETA Sec 2 (US state law), eIDAS regulation (European
                Union), Electronic Transactions Act 1999 (Australia), s.7
                Electronic Communications Act 2000 (UK), Law of the People’s
                Republic of China on Electronic Signature (China), PIPEDA
                (Canadian federal law), among others.
              </div>
            </div>
            <div className="flex-1">
              <Image
                src={require("@assets/legality/countries.png")}
                className="w-full h-auto"
                width={10}
                height={10}
                alt=""
              />
            </div>
          </div>
        </div> */}
        {/* <div className="text-center flex flex-col gap-6 max-w-[800px] mx-auto">
          <h1 className="text-4xl sm:text-5xl text-gray-800">
            Are eSignatures legal?
          </h1>
          <h2 className="text-violet-600 text-3xl sm:text-4xl">
            Short answer: YES!
          </h2>
          <h3 className="text-gray-500 text-xl font-semibold">
            For the long answer, keep reading.
          </h3>
          <div className="mx-auto w-[5px] h-24 bg-violet-600"></div>
          <div className="mx-auto border py-8 px-6 md:p-14 rounded-2xl shadow-lg my-8">
            <h2 className="text-gray-800 text-2xl mb-4">
              “[A contract or signature] may not be denied legal effect,
              validity, or enforceability solely because it is in electronic
              form”
            </h2>
            <h3 className="text-gray-500 text-xl font-semibold">
              ESIGN Act {`–`} USA, June 30, 2000
            </h3>
          </div>
          <p className="text-gray-500 text-xl font-normal text-left">
            The Electronic Signatures in Global and National Commerce Act
            (ESIGN) is an American law that authorizes the use of electronic
            records and electronic signatures.
            <br />
            <br />
            This is a single example of legislation that avails the use and
            legal effect of electronic signatures for business, across the
            world.
            <br />
            <br />
            Each country has its own laws regarding eSignatures but most of them
            consider electronic signatures and records as legally valid as “wet
            ink” signatures on paper.
            <br />
            <br />
            BoloForms complies with the laws of each country and region where
            eSignatures are legal.
          </p>
        </div> */}

        {/* <div className="max-w-screen-mxl mx-auto flex flex-col gap-14 w-full">
          <h2 className="text-gray-900 text-3xl md:text-4xl text-center">
            Are eSignatures legal in my country?
          </h2>
          <div className="flex items-center flex-col md:flex-row gap-10">
            <div className="w-full md:w-[40%]">
              <h3 className="text-gray-800 text-2xl">
                Where do you do business?
              </h3>
              <div className="max-w-[450px] h-[70px] border border-gray-200 rounded-full px-6 py-2 my-6">
                <select
                  className="h-full w-full border-none outline-none text-gray-500 bg-transparent text-lg"
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  {Object.keys(countries).map((countryName) => (
                    <option key={countryName} value={countryName}>
                      {countryName}
                    </option>
                  ))}
                </select>
              </div>
              {selectedCountry && (
                <div className="flex w-full gap-6">
                  <p className="text-md text-gray-900 font-bold">
                    Holds in court? <br />
                    {countries[selectedCountry].court ? (
                      <span className="text-xl font-semibold text-violet-700">
                        YES
                      </span>
                    ) : (
                      <span className="text-xl font-semibold text-red-500">
                        NO
                      </span>
                    )}
                  </p>
                  <p className="text-md text-gray-900 font-bold">
                    Can it be used for Business? <br />
                    {countries[selectedCountry].business ? (
                      <span className="text-xl font-semibold text-violet-700">
                        YES
                      </span>
                    ) : (
                      <span className="text-xl font-semibold text-red-500">
                        NO
                      </span>
                    )}
                  </p>
                </div>
              )}
            </div>
            <div className="flex-1">
              <Image
                src={`${BASE_ASSETS_URL}/boloforms-signature/countries.jpg`}
                alt=""
                width={10}
                height={10}
                className={`w-full border shadow-lg rounded-3xl`}
              />
            </div>
          </div>
          <div className="w-full h-[2px] bg-gray-300"></div>
        </div> */}

        <div className="max-w-screen-xl mx-auto flex flex-col gap-8 w-full px-4 lg:px-8 ">
          <div className="max-w-[900px] mx-auto text-center">
            <CtaOne
              heading2={`List of countries where eSignatures are legal`}
              paragraph={`An eSignature provides the same legal standing as a handwritten signature as long as it adheres to the requirements of the specific regulation it was created under.`}
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {countries.map((country, index) => (
              <div
                key={index}
                className="flex flex-col gap-2 border border-surface-dark rounded-xl transition-all duration-500 ease-in-out bg-surface-light overflow-hidden"
              >
                <div className="w-full relative bg-white">
                  <Image
                    src={`${BASE_ASSETS_URL}/v2/legality/legal-country2.svg`}
                    alt=""
                    width={10}
                    height={10}
                    className={`w-full ${styles.legalImages} grayscale-[1]`}
                  />
                  <div className="flex items-center gap-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <Image
                      src={`https://flagcdn.com/h20/${country.code}.png`}
                      alt=""
                      width="10"
                      height="10"
                      className={`w-12 h-8 border border-gray-400`}
                    />
                    <p className="text-sm uppercase font-bold text-gray-700">
                      {country.country}
                    </p>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-black text-2xl text-center mb-3">
                    {country.country}
                  </h3>
                  {country?.esignLaws?.map((law, index) => (
                    <p key={index} className="text-gray-900 text-xl text-left">
                      {law}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {/* <div className="w-full h-[2px] bg-gray-300"></div> */}
        </div>

        {/* company overview */}

        {/* <div className="w-full px-4 xxl:px-0 bg-cyan-50 pt-12 sm:pt-16 pb-16 sm:pb-20 border-y-2 border-gray-700">
          <CompanyOverview heading={`Company Overview`} />
        </div> */}

        {/* clients  */}
        <section className="bg-surface-dark py-20 mt-20">
          <div className="w-[1280px] max-w-full mx-auto pb-8">
            <h3 className="text-4xl md:text-5xl md:text-left text-center font-semibold  text-black">
              Industry leaders fly with BoloSign. <br /> It's your turn to rise
              with AI.
            </h3>
          </div>

          <CustomersMarquee customersData={industryLeadersCard} />
        </section>

        {/* <div className="w-full mx-auto text-center max-w-[800px] flex flex-col gap-8 px-4 lg:px-8 xxl:px-0">
          <h1 className="text-center max-w-4xl mx-auto text-black text-3xl sm:text-6xl">
            Looking to transition to eSignatures?
          </h1>
          <p className="text-xl text-gray-800">
            Join millions of professionals and business owners that have
            replaced manual paper signing for the speed and security of
            eSignatures.
          </p>
          <div className="flex justify-between flex-col md:flex-row items-center gap-4 sm:gap-6 md:gap-0 w-full h-full md:h-20 p-2 rounded-full bg-white">
            <input
              type="text"
              placeholder="Email address"
              className="h-full w-full px-3 py-3 md:py-0 md:pr-0 md:pl-7 md:flex-1 text-xl text-gray-800 outline-none bg-transparent placeholder-gray-800 border-r md:border-4-none border-l border-y border-gray-700 rounded-r-lg md:rounded-r-none rounded-l-lg"
              name=""
              id=""
            />
            <button
              onClick={() =>
                router.push(
                  `https://signature.boloforms.com/login?from=${
                    context.globalData.from || "ELECTRONIC_SIGNATURE_LEGALITY"
                  }`
                )
              }
              className="bg-violet-500 text-lg text-white h-full py-3 md:py-0 px-4 block rounded-l-lg md:rounded-l-none rounded-r-lg"
            >
              Try eSignature Free
            </button>
          </div>
        </div> */}

        {/* subscribe  */}
        {/* <div className="">
          <Subscribe />
        </div> */}

        {/* <div className="">
          <h2 className="mx-auto text-violet-600 font-semibold uppercase text-lg text-center">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <Blog
            heading="Common questions around eSignatures"
            BlogData={signatureBlog}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ElectricSignatureLegality;
